<script>
import Component from '~/sites/oknanebodvere/pages/articleList/index'
export default {
  extends: Component,
  nuxtI18n: {
    paths: {
      cs: '/clanky',
      de: '/artikel',
      en: '/articles',
      sk: '/clanky',
    },
  },
}
</script>
